"use client";
// app/components/tracking/InteractionPageViewTracker.tsx
// Route değiştiğinde /general/interactions/track'e sayfa "view" eventi gönderir.
//
// Sadece burada listelenen statik route'lar için trackGeneric atılır.
// Model bazlı detay sayfaları (ürün, kategori, marka, mağaza, kampanya,
// kupon, koleksiyon, help sorusu) kendi sayfa bileşenlerinde gerçek id ile
// trackInteraction(view) attığından buradan HARİÇ tutulur — çift sayım olmaz.
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackGeneric } from "@/app/lib/tracking/interactions";

// Tam eşleşme: pathname → key
const EXACT_ROUTES: Record<string, string> = {
  "/": "page_home",
  "/sepet": "page_sepet",
  "/aramasonucu": "page_aramasonucu",
  "/kampanyalar": "page_kampanyalar",
  "/urunler": "page_urunler",
  "/help": "page_help",
  "/sorular": "page_sorular",
  "/canli-destek": "page_canli-destek",
  "/kargo-takibi": "page_kargo-takibi",
  "/kargo-teslimat": "page_kargo-teslimat",
  "/gizlilik": "page_gizlilik",
  "/aydinlatma-metni": "page_aydinlatma-metni",
  "/kullanim-kosullari": "page_kullanim-kosullari",
  "/sartlar-ve-kosullar": "page_sartlar-ve-kosullar",
  "/cookie-policy": "page_cookie-policy",
  "/cerez-tercihlerimi-yonet": "page_cerez-tercihlerimi-yonet",
  "/iade": "page_iade",
  "/hakkimizda": "page_hakkimizda",
  "/iletisim": "page_iletisim",
  "/auth/login": "page_auth_login",
  "/auth/register": "page_auth_register",
  "/account/checkout": "page_checkout",
  "/account/favorites": "page_account_favorites",
  "/account/menus": "page_account_menus",
  "/account/orders": "page_account_orders",
  "/account/profile": "page_account_profile",
  "/account/favorite-products": "page_account_favorite-products",
  "/account/followed-stores": "page_account_followed-stores",
  "/account/recently-viewed": "page_account_recently-viewed",
  "/account/reorder": "page_account_reorder",
  "/account/coupons": "page_account_coupons",
  "/account/collections": "page_account_collections",
  "/account/favorite-searches": "page_account_favorite-searches",
  "/account/addresses": "page_account_addresses",
  "/account/reviews": "page_account_reviews",
};

// Prefix eşleşmesi: dinamik segmentli ama model id'si olmayan sayfalar.
// Sıra önemli — daha spesifik path önce gelmeli.
const PREFIX_ROUTES: [RegExp, string][] = [
  [/^\/account\/orders\/[^/]+\/cancel$/, "page_account_order_cancel"],
  [/^\/account\/orders\/[^/]+\/return\/confirm$/, "page_account_order_return_confirm"],
  [/^\/account\/orders\/[^/]+\/return$/, "page_account_order_return"],
  [/^\/account\/orders\/[^/]+$/, "page_account_order_detail"],
  [/^\/help\/[^/]+$/, "page_help_category"],
  [/^\/urun-degerlendirmesi\/[^/]+$/, "page_urun-degerlendirmesi"],
  [/^\/benzer-urunler\/[^/]+$/, "page_benzer-urunler"],
];

const resolveKey = (pathname: string): string | null => {
  const exact = EXACT_ROUTES[pathname];
  if (exact) return exact;
  for (const [pattern, key] of PREFIX_ROUTES) {
    if (pattern.test(pathname)) return key;
  }
  return null;
};

const InteractionPageViewTracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    const key = resolveKey(pathname);
    if (key) trackGeneric(key, "view");
  }, [pathname]);

  return null;
};

export default InteractionPageViewTracker;
